import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconCodeStyle0 = gravityIconIndividualCss;

const GravityIconCode = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: 'e2a8dc44aa52a72c96aed426d81dc32a92f6fe89', color: this.color, size: this.size }, h("svg", { key: '9dfaac8ddc80734d27b2a91739d51c0f877d90fa', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: 'dcec60012d4288f0f37bb1d62cea31e8d4f8b5a3', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M12.32 5a.5.5 0 0 0-.48.36l-3.08 11a.5.5 0 0 0 .47.67h.46a.52.52 0 0 0 .49-.36l3.07-11a.5.5 0 0 0-.47-.67h-.46Zm6.41 5.65-3.39-3.39a.4.4 0 0 0-.28-.12.37.37 0 0 0-.27.11l-.44.44a.36.36 0 0 0-.11.26.44.44 0 0 0 .11.28L17.12 11l-2.77 2.77a.44.44 0 0 0-.11.28c0 .098.04.192.11.26l.44.44a.37.37 0 0 0 .27.11.4.4 0 0 0 .28-.12l3.39-3.39a.5.5 0 0 0 0-.7Zm-15.59.7 3.39 3.39a.4.4 0 0 0 .28.12.37.37 0 0 0 .27-.11l.44-.44a.41.41 0 0 0 .11-.26.4.4 0 0 0-.12-.28L4.75 11l2.76-2.77A.4.4 0 0 0 7.63 8a.41.41 0 0 0-.11-.26l-.44-.44a.37.37 0 0 0-.27-.11.4.4 0 0 0-.28.12l-3.39 3.34a.48.48 0 0 0 0 .7Z", fill: "currentColor" }))));
    }
};
GravityIconCode.style = GravityIconCodeStyle0;

export { GravityIconCode as gravity_icon_code };

//# sourceMappingURL=gravity-icon-code.entry.js.map